import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';

import { AddCoachMeetingDialogComponent } from 'dialog/add-coach-meeting-dialog/add-coach-meeting-dialog.component';
import { CoacheesEditObserversComponent } from 'presentation/app-sidebar/sidebar-coachees/coachees-edit-observers/coachees-edit-observers.component';
import { SidebarCoachee } from 'presentation/app-sidebar/sidebar-coachees/sidebar-coachees.models';
import { SidebarCoacheesStore } from 'presentation/app-sidebar/sidebar-coachees/sidebar-coachees.store';
import { IUser } from 'user/user';

import { SidebarCoacheesController } from './sidebar-coachees.controller';

@Component({
	selector: 'spr-sidebar-coachees',
	templateUrl: './sidebar-coachees.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [SidebarCoacheesStore, SidebarCoacheesController],
	host: {
		class: 'flex flex-auto flex-col items-stretch',
	},
})
export class SidebarCoacheesComponent {
	@Input() public chatUserId: string;

	@Output() public openPlan: EventEmitter<string>;
	@Output() public openChat: EventEmitter<string>;

	constructor(
		private _cd: ChangeDetectorRef,
		public controller: SidebarCoacheesController
	) {
		this.openPlan = controller.openPlan;
		this.openChat = controller.openChat;
	}

	public trackByCoachee(index: number, coachee: SidebarCoachee): string {
		return coachee.entity.id;
	}

	public onSearchTermChange(term: string) {
		this.controller.updateSearchTerm(term);
	}
}
